<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 哮天系统
                </el-breadcrumb-item>
				<el-breadcrumb-item>
					设备元器件关联一览
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.equipmentId" placeholder="请选择设备" filterable style="width:180px;">
					<el-option key="" label="请选择设备" value=""></el-option>
					<el-option v-for="item in equipmentKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.typeId" placeholder="请选择元器件类型" filterable @change="onChangeTypeId" style="width:180px;">
					<el-option key="" label="请选择元器件类型" value=""></el-option>
					<el-option v-for="item in productTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.seriesId" placeholder="请选择元器件系列" filterable style="width:180px;">
					<el-option key="" label="请选择元器件系列" value=""></el-option>
					<el-option v-for="item in productSeriesKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-input v-model="query.productName" placeholder="元器件" class="handle-input mr10" style="width:200px;"></el-input>&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
			</div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="equipmentId" label="设备" width="250" :formatter="equipmentFormatter"></el-table-column>
				<el-table-column prop="productRemark" label="元器件"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete-batch']"
                >批量删除</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchEquipmentProductMappingData, deleteEquipmentProductMapping, getEnumValueKV, getProductSeriesKV, getPotentialResourcesKeyByType } from '../../../api/index';
export default {
    name: 'equipment-product-mapping',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            pageTotal: 0,
			productTypeKV:{},
			productSeriesKV:{},
			equipmentKV:{},
			productTypeEnumCode:1003,
			equipmentType:0,
			multipleSelection:{},
			controll:{}
        };
    },
    created() {
		this.controll = getControll("equipment-product-mapping");
        this.getData();
		this.getProductType();
		this.getEquipments();
    },
    methods: {
		getEquipments() {
			getPotentialResourcesKeyByType(this.equipmentType).then(res => {
				if (res.code == 0 ) {
					this.equipmentKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		equipmentFormatter(row, column, cellValue) {
			for (var i = 0; i < this.equipmentKV.length; i++) {
				if (this.equipmentKV[i].key === cellValue){
					return this.equipmentKV[i].value;
				}
			}
			return cellValue;
		},
		//获取产品类型
		getProductType() {
			getEnumValueKV(this.productTypeEnumCode).then(res => {
				if (res.code == 0 ) {
					this.productTypeKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		//产品类型变更
		onChangeTypeId(value) {
			this.productSeriesKV = {};
			if (!value) {
				return;
			}
			getProductSeriesKV(value).then(res => {
				if (res.code == 0 ) {
					this.productSeriesKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
        // 获取变化数据
        getData() {
            fetchEquipmentProductMappingData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		 // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		// 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteEquipmentProductMapping([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteEquipmentProductMapping(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
